import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [players, setPlayers] = useState([]);
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [gangPlayers, setGangPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState(''); // State สำหรับช่องค้นหา

  const API_URL = '/api/proxy';
  // const API_URL = '/players.json';
  // /players.json


  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(API_URL);
        setPlayers(response.data);
        setFilteredPlayers(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchPlayers();
  }, []);
  

  // ฟังก์ชันสำหรับจัดการการค้นหา
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    // กรองข้อมูลผู้เล่นตามชื่อ
    const filtered = players.filter((player) =>
      player.name.toLowerCase().includes(query)
    );
    setFilteredPlayers(filtered);
  };

  const extractValueInBrackets = (name) => {
    const match = name.match(/\[(.*?)\]/); // ใช้ RegEx เพื่อจับค่าภายใน []
    return match ? match[1].trim() : null; // ถ้าพบค่าใน [] ให้คืนค่าที่จับได้
  };

  const playerNamesInBrackets = players.map(player => extractValueInBrackets(player.name));

  // ฟังก์ชันสำหรับจัดกลุ่มผู้เล่นตามชื่อใน []
  const groupPlayersByBracketValue = (players) => {
    const grouped = players.reduce((acc, player) => {
      const groupName = extractValueInBrackets(player.name);
      if (groupName) {
        if (!acc[groupName]) {
          acc[groupName] = 0; // ถ้ายังไม่มี key ใน accumulator ให้เริ่มต้นเป็น 0
        }
        acc[groupName] += 1; // เพิ่มจำนวนผู้เล่นในกลุ่มนั้น
      }
      return acc;
    }, {});

    // แปลงข้อมูลใน grouped เป็นรูปแบบ [{name: 'DRMD', amount: '2'}, {name: 'VIP', amount: '2'}]
    return Object.keys(grouped).map(groupName => ({
      name: groupName,
      amount: grouped[groupName].toString() // แปลงจำนวนให้เป็น string
    }));
  };

  // จัดกลุ่มผู้เล่นและนับจำนวน
  const groupedPlayers = groupPlayersByBracketValue(players);

  console.log(groupedPlayers);
  

  return (
    <div className="container mt-5">
      <h1 className="text-center">FiveM Players Online</h1>

      {/* ช่องค้นหา */}
      <div className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="ค้นหาชื่อผู้เล่น..."
          value={search}
          onChange={handleSearch}
        />
      </div>
      
      {isLoading ? (
        <div className="text-center mt-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <div className="alert alert-danger text-center mt-3">{error}</div>
      ) : (
        <div>
          <div className="mt-3">
              <h4>หน่วยงานและแกงค์ที่ออน:</h4>
              {groupedPlayers
                .sort((a, b) => a.name.localeCompare(b.name)) // จัดเรียง A-Z ตามชื่อกลุ่ม
                .map((e) => (
                  <button type="button" className="btn btn-primary m-2" key={e.name}>
                    {e.name + ' '}
                    <span className="badge" style={{ backgroundColor: 'white', color: 'black' }}>
                      {e.amount}
                    </span>
                  </button>
              ))}
          </div>
        
          <div className="mt-3">
            <h4>Total Players: {filteredPlayers.length}</h4>
            <ul className="list-group mt-3">
              {filteredPlayers.map((player, index) => (
                <li key={index} className="list-group-item">
                  <strong>{player.name}</strong> - Ping: {player.ping}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
